"use client"

import { Email } from "./types"

type EmailListProps = {
	title: string
	emails: Email[]
	selectedId: string | null
	onSelect: (id: string) => void
}

export default function EmailList({ title, emails, selectedId, onSelect }: EmailListProps) {
	return (
		<div
			className="
				flex-1 min-h-0
				bg-[#0a0015]
				border-2 border-t-[#ff003c] border-l-[#ff003c] border-b-[#00f5ff] border-r-[#00f5ff]
				overflow-y-auto
			"
		>
			<div className="bg-gradient-to-r from-[#bf00ff] to-[#ff2d78] text-black font-bold text-sm px-2 py-1 sticky top-0">
				{title}
			</div>
			{emails.length === 0 ? (
				<div className="p-4 text-sm italic text-[#7755aa]">This folder is empty.</div>
			) : (
				<table className="w-full text-sm border-collapse">
					<thead>
						<tr className="bg-[#1a0033] border-b-2 border-[#ff6f00]">
							<th className="text-left font-bold px-2 py-1 border-r border-[#39ff14] text-[#39ff14]">Subject</th>
							<th className="text-left font-bold px-2 py-1 border-r border-[#39ff14] text-[#39ff14]">From</th>
							<th className="text-left font-bold px-2 py-1 w-[9rem] text-[#39ff14]">Date</th>
						</tr>
					</thead>
					<tbody>
						{emails.map((email) => (
							<tr
								key={email.id}
								onClick={() => onSelect(email.id)}
								className={`
									cursor-pointer border-b border-[#1a0033]
									${selectedId === email.id
										? "bg-[#ffe600] text-black"
										: "text-[#e0d0ff] hover:bg-[#2a0050] hover:text-[#00f5ff]"
									}
								`}
							>
								<td className="px-2 py-1 text-xl">{email.subject}</td>
								<td className="px-2 py-1 text-xl whitespace-nowrap">{email.from}</td>
								<td className="px-2 py-1 text-xl whitespace-nowrap">{email.date}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	)
}
